import { useState } from 'react';
import Countdown, { CountdownRendererFn } from 'react-countdown';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import useAuth from '@/hooks/useAuth';
import ROUTES from '@/router/routes';

type MomentProps = {
  value: string;
  label: string;
};

const Moment = ({ value, label }: MomentProps) => {
  return (
    <div className="flex flex-col gap-y-2 items-center h-fit md:h-8 w-10">
      <span className="text-2xl md:text-3xl xl:text-4xl 2xl:text-5xl">
        {value}
      </span>
      <span className="font-bold text-xs">{label}</span>
    </div>
  );
};

/**
 * Notar que no existe CountdownMobile, este también se usa en mobile.
 */
export const CountdownDesktop = () => {
  const navigate = useNavigate();
  const { userInitialData } = useAuth();
  const [isInBanMode, setIsInBanMode] = useState(userInitialData?.veda);
  const isRankingProcessingPending = !userInitialData?.fecha_publicada;
  /* (implícito dentro de "fecha_publicada": && !userInitialData?.primera_fecha) */
  const lastText = userInitialData?.primera_fecha
    ? 'PARA TU DEBUT'
    : 'PARA LA PRÓXIMA FECHA';
  const renderer: CountdownRendererFn = ({ formatted }) => {
    return (
      <div className="flex flex-col md:flex-row gap-x-7 gap-y-3 my-2 items-center">
        <h3 className="font-bold text-[18px] md:text-[28px] 2xl:text-[32px] text-center">
          {formatted.days !== '01' ? 'FALTAN' : 'FALTA'}
        </h3>
        <div className="flex gap-x-3 md:flex-row w-full justify-center ">
          <Moment
            label={formatted.days !== '01' ? 'DÍAS' : 'DÍA'}
            value={formatted.days}
          />
          <span className="text-sm md:text-lg 2xl:text-3xl">:</span>
          <Moment label="HS" value={formatted.hours} />
          <span className="text-sm md:text-lg 2xl:text-3xl">:</span>
          <Moment label="MIN" value={formatted.minutes} />
          <span className="text-sm md:text-lg 2xl:text-3xl">:</span>
          <Moment label="SEG" value={formatted.seconds} />
        </div>
        <h3 className="font-bold text-center text-nowrap text-[18px] md:text-[28px] 2xl:text-[32px]">
          {lastText}
        </h3>
      </div>
    );
  };

  const nextDate =
    userInitialData?.comienzo_veda
      ?.split(' ')[0]
      .split('/')
      .reverse()
      .join('-') +
    'T' +
    userInitialData?.comienzo_veda?.split(' ')[1];

  let specialMessage;
  if (userInitialData?.todoPublicado) {
    specialMessage = (
      <h3 className="text-sm md:text-3xl !leading-7 py-8 text-center font-bold">
        <span className="text-wrap">
          Gran DT ya finalizó. ¡Te esperamos en la próxima edición!
        </span>{' '}
      </h3>
    );
  } else if (isInBanMode && !isRankingProcessingPending) {
    specialMessage = (
      <h3 className="py-8  flex flex-1">
        <div className="text-sm/8 md:text-3xl/8 text-nowrap font-bold align-middle flex-grow text-center">
          SE ESTÁ JUGANDO LA FECHA
        </div>
        {/*
        <div className="flex-grow-0 min-w-14 text-nowrap">
          <Button
            className="bg-white text-nowrap text-gdt-blue ml-4 md:ml-14 md:block text-[11px] py-1 px-2 "
            type="button"
            variant="primary"
            onClick={() => navigate(ROUTES.recentMatchStats)}
          >
            Fichas de Partidos
          </Button>
        </div>
        */}
      </h3>
    );
  } else if (isRankingProcessingPending) {
    specialMessage = (
      <h3 className="text-sm md:text-3xl !leading-7 py-8 text-center font-bold text-wrap">
        <span className="text-nowrap">
          SE ESTÁN PROCESANDO LOS PUNTOS DE LA FECHA.
        </span>{' '}
        <span className="text-nowrap"> PRONTO PODRÁS VER TU PUNTAJE. </span>
      </h3>
    );
  }

  return (
    <div
      className={`flex px-12 xl:px-36 items-center justify-center gap-x-7 w-full h-fit md:h-32 bg-gdt-blue-dark md:bg-gray-900 text-white md:bg-[url('/assets/images/countdownBackground.png')] bg-cover bg-no-repeat md:rounded-lg`}
    >
      {specialMessage || (
        <>
          <Countdown
            className=""
            date={new Date(nextDate)}
            renderer={renderer}
            zeroPadTime={2}
            onComplete={() => setIsInBanMode(true)}
          />
          <Button
            className="bg-white text-gdt-blue ml-0 xl:ml-14 hidden md:block text-xs xl:text-sm"
            type="button"
            variant="primary"
            onClick={() => navigate(ROUTES.myTeam11)}
          >
            Mejorá tu equipo
          </Button>
        </>
      )}
    </div>
  );
};
